module.exports = __webpack_public_path__ + "assets/3d6d9b788815473e8ed38edaf01cc868.mp3";